import { REQUEST_STATUS } from 'src/constants/CommonConstants';
import { AUTH_ACTIONS } from 'src/containers/auth-container/actions/AuthActions';
import { CaseDefaultProps } from 'src/containers/case-container/CasePropTypes';
import { CASE_ACTIONS } from '../actions/CaseActions';

const initialState = () => ({
    currentRecord: { ...CaseDefaultProps },
    populatedCurrentRecord: { ...CaseDefaultProps },

    search: {
        data: [],
        currentPage: 0,
        pages: 0,
        count: 0,
    },

    upsertReqStatus: null,
    searchReqStatus: null,
});

export default (state = initialState(), action) => {
    switch (action.type) {
    // SEARCH
        case CASE_ACTIONS.CASE_SEARCH: {
            return {
                ...state,
                searchReqStatus: REQUEST_STATUS.PENDING,
            };
        }
        case CASE_ACTIONS.CASE_SEARCH_SUCCESS: {
            return {
                ...state,
                search: action.data,
                searchReqStatus: REQUEST_STATUS.SUCCESS,
            };
        }
        case CASE_ACTIONS.CASE_SEARCH_ERROR: {
            return {
                ...state,
                searchReqStatus: REQUEST_STATUS.ERROR,
            };
        }

        // UPSERT
        case CASE_ACTIONS.CASE_UPSERT: {
            return {
                ...state,
                upsertReqStatus: REQUEST_STATUS.PENDING,
            };
        }
        case CASE_ACTIONS.CASE_UPSERT_SUCCESS: {
            return {
                ...state,
                currentRecord: action.data,
                populatedCurrentRecord: action.populatedData,
                upsertReqStatus: REQUEST_STATUS.SUCCESS,
            };
        }
        case CASE_ACTIONS.CASE_UPSERT_ERROR: {
            return {
                ...state,
                upsertReqStatus: REQUEST_STATUS.ERROR,
            };
        }

        // RESET
        case CASE_ACTIONS.CASE_RESET: {
            return {
                ...state,
                currentRecord: { ...CaseDefaultProps },
            };
        }
        // LOGOUT
        case AUTH_ACTIONS.LOGOUT:
            return {
                ...initialState(),
            };
        default:
            return state;
    }
};
